<template>
    <transition name="fade">
        <div
            class="overlay-loading"
            v-show="isLoading"
        >
            <div class="loading-wrapper">
                <img
                    src="@/assets/img/loading.gif"
                    alt="Carregando..."
                    class="w-8"
                />
            </div>
        </div>
    </transition>
</template>

<script setup>
import { useLoading } from '@/composables/useLoading';

const { isLoading } = useLoading();
</script>

<style lang="scss" scoped>
.overlay-loading {
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    position: absolute;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #fcfbf9;
    z-index: 999;

    .loading-wrapper {
        padding: 2rem;
    }
}
</style>
